import { FC, memo } from 'react'
import { Alert, AlertDescription, AlertIcon, Button } from '@chakra-ui/react'

import { UploadFile } from 'types'
import { openFile } from 'utils/files'
import { Document } from 'components/icons'
import { FILE_EXTENSION_BLACK_LIST } from 'constants/files'

type Props = {
  file: UploadFile
}

const OpenEstaticFileButton: FC<Props> = ({ file }) => {
  const IsFileExtensionOnBlackList = FILE_EXTENSION_BLACK_LIST.includes(file.extension as string)

  if (IsFileExtensionOnBlackList) {
    return (
      <Alert rounded="md">
        <AlertIcon />
        <AlertDescription>
          Esse arquivo é convertido para JPEG pela API posteriormente, então quando for visualizar ele nas respostas de
          um formulário, ele vem como JPEG e não tem problema.
        </AlertDescription>
      </Alert>
    )
  }

  return (
    <Button variant="outline" leftIcon={<Document />} onClick={() => openFile(file.url || '')}>
      Abrir arquivo
    </Button>
  )
}

export default memo(OpenEstaticFileButton)
